<form nz-form [formGroup]="input.formGroup" (ngSubmit)="onSubmit()" nzLayout="horizontal" class="p-4">
	<div class="modal-body">
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="label">
				<app-invalid-form-indicator [form]="input.formGroup" field="label"
					class="me-3"></app-invalid-form-indicator>
				Label
			</nz-form-label>
			<nz-form-control [nzSpan]="14"
				[nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 100 characters'}}">
				<input nz-input id="label" formControlName="label"
					[attr.readonly]="isProductWorkflow || null" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="orderIndex">
				<app-invalid-form-indicator [form]="input.formGroup" field="orderIndex"
					class="me-3"></app-invalid-form-indicator>
				Order Index
			</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
				<input nz-input type="number" id="orderIndex" formControlName="orderIndex"
					[attr.readonly]="isProductWorkflow || null" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="buttonType">
				<app-invalid-form-indicator [form]="input.formGroup" field="buttonType"
					class="me-3"></app-invalid-form-indicator>
				Button Type
			</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
				<nz-select formControlName="buttonType" nzPlaceHolder="Select an option"
					[nzDisabled]="isProductWorkflow">
					<nz-option nzValue="Default" nzLabel="Default"></nz-option>
					<nz-option nzValue="Primary" nzLabel="Primary"></nz-option>
					<nz-option nzValue="Dashed" nzLabel="Dashed"></nz-option>
					<nz-option nzValue="Text" nzLabel="Text"></nz-option>
					<nz-option nzValue="Link" nzLabel="Link"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="buttonStyle">
				<app-invalid-form-indicator [form]="input.formGroup" field="buttonStyle"
					class="me-3"></app-invalid-form-indicator>
				Button Style
			</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
				<nz-select formControlName="buttonStyle" nzPlaceHolder="Select an option"
					[nzDisabled]="isProductWorkflow">
					<nz-option nzValue="Default" nzLabel="Default"></nz-option>
					<nz-option nzValue="Danger" nzLabel="Danger"></nz-option>
					<nz-option nzValue="Ghost" nzLabel="Ghost"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="alignment">
				<app-invalid-form-indicator [form]="input.formGroup" field="alignment"
					class="me-3"></app-invalid-form-indicator>
				Alignment
			</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
				<nz-select formControlName="alignment" nzPlaceHolder="Select an option"
					[nzDisabled]="isProductWorkflow">
					<nz-option nzValue="Left" nzLabel="Left"></nz-option>
					<nz-option nzValue="Right" nzLabel="Right"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item nz-tooltip="Font Awesome 6 (free)">
			<nz-form-label [nzSpan]="6" nzFor="icon">
				<app-invalid-form-indicator [form]="input.formGroup" field="icon"
					class="me-3"></app-invalid-form-indicator>
				Icon
			</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-input-group [nzSuffix]="suffixIcon">
					<input nz-input type="text" placeholder="Index" formControlName="icon"
						[attr.readonly]="isProductWorkflow || null" />
				</nz-input-group>

				<ng-template #suffixIcon>
					<span *ngIf="icon">
						Preview:
						<fa-icon *ngIf="icon" [icon]="['fas', icon]"></fa-icon>
					</span>
				</ng-template>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-control [nzOffset]="6" [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
				<div class="flex flex-col gap-2">
					<label nz-checkbox formControlName="requiredValidForm"
						[nzDisabled]="isProductWorkflow">
						<app-invalid-form-indicator [form]="input.formGroup"
							field="requiredValidForm"
							class="me-3"></app-invalid-form-indicator>
						Form must be valid
					</label>
				</div>
			</nz-form-control>
		</nz-form-item>


		<nz-divider nzText="Actions"></nz-divider>
		<button nz-button nzType="dashed" class="mb-1 me-1" (click)="addAction()">+ Add Action</button>

		<h4>Actions</h4>
		<nz-steps nzDirection="vertical">
			<ng-container *ngFor="let action of input.actions">
				<ng-container [ngSwitch]="action._actionType">
					<nz-step *ngSwitchCase="'CancelTicket'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Cancel Ticket"
						nzDescription="Cancels the ticket"></nz-step>
					<nz-step *ngSwitchCase="'CloseTicket'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Close Ticket"
						nzDescription="Closes the ticket"></nz-step>
					<nz-step *ngSwitchCase="'SaveForm'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Save"
						nzDescription="Saves any captured details, but leaves ticket step and state unchanged"></nz-step>
					<nz-step *ngSwitchCase="'CancelForm'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Cancel"
						nzDescription="Discards any changed made."></nz-step>
					<nz-step *ngSwitchCase="'Movement'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Move to step & state"
						[nzDescription]="'Change state to: ' + getStateName(action)"></nz-step>
					<nz-step *ngSwitchCase="'AdditionalCommunication'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Additional Communication"
						nzDescription="Compose additional (optional) communications"></nz-step>
					<nz-step *ngSwitchCase="'RequiredCommunication'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Required Communication"
						[nzDescription]="getCommunicationName(action)"></nz-step>
					<nz-step *ngSwitchCase="'SplitTicketGroup'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Split Ticket Group"
						nzDescription="Tickets linked together get unlinked."></nz-step>
					<nz-step *ngSwitchCase="'AdditionalComment'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Additional Comment"
						nzDescription="Prompt for additional comment when clicking button."></nz-step>
					<nz-step *ngSwitchCase="'ForkTicket'"
						[nzStatus]="action.formGroup.valid ? 'process' : 'error'"
						(dblclick)="viewAction(action)" nzTitle="Fork Ticket"
						[nzDescription]="'Creates a copy of the ticket in workflow ID: ' + (action.payload.movementWorkflowStepStatusId || '-')">
					</nz-step>>

					<nz-step *ngSwitchCase="'ProductValidate'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Product Validation"
						nzDescription="validate ticket inputs."></nz-step>
					<nz-step *ngSwitchCase="'ProductCreateBeneficiary'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Create Beneficiary"
						nzDescription="Create Beneficiary."></nz-step>
					<nz-step *ngSwitchCase="'ProductScheduleBenefitPayment'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)"
						nzTitle="Product Schedule Benefit Payment"
						nzDescription="ProductScheduleBenefitPayment."></nz-step>
					<nz-step *ngSwitchCase="'ProductApprovalQueue'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Product Approval Queue"
						nzDescription="Product Approval Queue."></nz-step>
					<nz-step *ngSwitchCase="'ProductApprovalApprove'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Product Approval Approve"
						nzDescription="Product Approval Approve."></nz-step>
					<nz-step *ngSwitchCase="'ProductApprovalDecline'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Product Approval Decline"
						nzDescription="Product Approval Decline."></nz-step>

					<nz-step *ngSwitchCase="'InvoiceCreate'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Create Invoice"
						nzDescription="Create Invoice."></nz-step>
					<nz-step *ngSwitchCase="'InvoiceApprovalQueue'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Invoice Approval Queue"
						nzDescription="Invoice Approval Queue."></nz-step>
					<nz-step *ngSwitchCase="'InvoiceApprovalApprove'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Invoice Approval Approve"
						nzDescription="Invoice Approval Approve."></nz-step>
					<nz-step *ngSwitchCase="'InvoiceApprovalDecline'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Invoice Approval Decline"
						nzDescription="Invoice Approval Decline."></nz-step>
					<nz-step *ngSwitchCase="'InvoiceSchedulePayment'"
						[nzStatus]="action.formGroup.valid?'process':'error'"
						(dblclick)="viewAction(action)" nzTitle="Invoice Schedule Payment"
						nzDescription="Invoice Schedule Payment."></nz-step>
				</ng-container>
			</ng-container>
		</nz-steps>
	</div>

	<div class="modal-footer" style="text-align: right;">
		<nz-form-item>
			<nz-form-control>
				<button *ngIf="!input.formGroup.valid" nz-button nzType="default" class="me-1"
					(click)="doClose()">Close</button>
				<button *ngIf="input.formGroup.valid" nz-button nzType="primary"
					(click)="doClose()">Close</button>
				<button *ngIf="!isProductWorkflow" class="me-1" nz-button nzDanger="" nzType="primary"
					(click)="doDelete()">Delete</button>
			</nz-form-control>
		</nz-form-item>
	</div>
</form>